import { render, staticRenderFns } from "./flex.vue?vue&type=template&id=8aa661cc&"
import script from "./flex.vue?vue&type=script&lang=js&"
export * from "./flex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports